import React from "react";
import styles from "./styles.module.scss";

const SobreV2: React.FC = () => {
  return (
    <section id="sobre" className={styles.sobre}>
      <div className={styles.row}>
        <div className={styles.textCol}>
          <h2>O que é o Parceiros Promo?</h2>
          <p>
            O Parceiros Promo é o maior e mais completo programa de parcerias do{" "}
            <a
              href="https://www.amopromo.com"
              target="_blank"
              rel="noreferrer"
              className={styles.highlight}
            >
              Grupo Amo Promo
            </a>
            .
          </p>
          <p>
            É mais do que um sistema de afiliados, é um ecossistema completo e
            bem amparado para todos que desejam monetizar com a divulgação de
            nossos produtos e serviços.
          </p>
        </div>

        <div className={styles.mediaCol}>
          <img
            src="/images-capa2/sobre/card.png"
            alt="Parceiro Promo usando o aplicativo"
            title="Parceiros Promo"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.display = "none";
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default SobreV2;
